
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 98 8","fill":"#fff","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.84.046h1.906l2.865 4.377V.046h1.795v7.378h-1.88l-2.879-4.39v4.39H8.84V.046zM20.732-.2c1.402 0 2.373.529 3.16 1.352l-1.243 1.18c-.517-.504-1.18-.823-1.919-.823-1.316 0-2.164.983-2.164 2.226 0 1.242.848 2.225 2.164 2.225.739 0 1.402-.32 1.919-.823l1.205 1.18c-.738.774-1.759 1.352-3.124 1.352-2.336 0-3.996-1.734-3.996-3.936 0-2.2 1.661-3.933 3.998-3.933zM27.735-.2h.32l3.614 7.624h-1.942l-.37-.762h-2.913l-.357.762h-1.942L27.735-.2zm1.008 5.57L27.895 3.5h-.026l-.86 1.869h1.734zM32.549.046h1.906l2.865 4.377V.046h1.795v7.378h-1.88l-2.879-4.39v4.39H32.55V.046zM40.626.046h1.906l2.866 4.377V.046h1.795v7.378H45.31l-2.877-4.39v4.39h-1.808V.046zM50.697 3.857L48.077.044h2.04l1.477 2.213L53.082.044h2.028l-2.62 3.813v3.566h-1.795V3.857h.002zM58.892.046h1.882L62.262 3.6 63.75.046h1.881L62.373 7.67h-.222L58.892.046zM67.875-.2h.32l3.615 7.624h-1.942l-.37-.762h-2.914l-.356.762h-1.943L67.875-.2zm1.008 5.57L68.035 3.5h-.025l-.86 1.869h1.733zM72.931.046h1.808v5.828h3.21v1.55H72.93V.045zM79.1.046h1.808v5.828h3.21v1.55H79.1V.045zM85.27.046h4.881v1.599h-3.074v1.327h2.84v1.575h-2.84v1.328h3.21v1.55H85.27V.044zM93.33 3.857L90.712.044h2.041l1.476 2.213L95.716.044h2.028l-2.62 3.813v3.566H93.33V3.857zM5.912.02v3.905H5.91v.073c0 1.164-.753 2.107-1.925 2.107a2.115 2.115 0 01-2.123-2.107V.02H.1v4.238c0 1.985 1.74 3.595 3.887 3.595 2.147 0 3.689-1.61 3.689-3.594V.02H5.912z"}})])
          )
        }
      }
    